module.exports = __webpack_public_path__ + "static/img/serviceBg.da8f8c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/serviceBg.png
// module id = ZSlD
// module chunks = 15